import { createBrowserRouter } from 'react-router-dom';

import RouteErrorPage from 'components/RouteErrorPage';
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';

const router = createBrowserRouter(
  [
    { ...MainRoutes, errorElement: <RouteErrorPage /> },
    { ...LoginRoutes, errorElement: <RouteErrorPage /> }
  ],
  { basename: import.meta.env.VITE_APP_BASE_NAME }
);

export default router;
